/** @jsx jsx */
import { jsx, Box, Container, Flex } from 'theme-ui';
/* eslint-disable react/no-danger */
import React from 'react';

// Node Types
import { SectionComponent } from '@codersclan/gatsby-theme-airfleet/src/@types';

// Types
import { Section } from '../../@codersclan/gatsby-theme-airfleet/@types/section';

// Components
import Text, { TEXT_TYPES } from '../../components/text';
import IconColumn from '../../components/iconColumn';

// Styles
import { baseStyle } from './style';

interface IconsRepeaterProps extends Section {
  iconsRepeater: {
    title: string;
    content: string;
    icons: {
      title: string;
      paragraphText: string;
      numberTitle: string;
      subtextTitle: string;
      alternativeText: string;
      image: ImageType;
    }[];
  }
};

const IconsRepeater: SectionComponent<IconsRepeaterProps> = React.memo(
  ({ iconsRepeater }) => (
    <Box>
      <Container sx={baseStyle.mainContainer}>
        <Box sx={baseStyle.innerContainer}>
          <Text type={TEXT_TYPES.H2} sx={baseStyle.title} lines="2">
            {iconsRepeater.title}
          </Text>
          <Text
            type={TEXT_TYPES.DISPLAY_SUBHEAD}
            sx={baseStyle.subtitle}
            lines="2"
          >
            <span dangerouslySetInnerHTML={{ __html: iconsRepeater.content }} />
          </Text>
          <Flex sx={baseStyle.repeaterContainer}>
            {iconsRepeater.icons.map((iconItem, idx: number) => (
              <IconColumn
                // eslint-disable-next-line react/no-array-index-key
                key={idx}
                image={iconItem.image}
                title={iconItem.title}
                paragraph={iconItem.paragraphText}
                number={iconItem.numberTitle}
                subtext={iconItem.subtextTitle}
                sx={baseStyle.iconColor}
              />
            ))}
          </Flex>
        </Box>
      </Container>
    </Box>
  ),
);

export default IconsRepeater;
